import React from 'react'
import Button from '@mui/material/Button'
import PermissionGate from '../../../../helpers/PermissionGate'
import { useState, lazy, Suspense } from 'react'

const TransactionsCounterpartiesMergeModal = lazy(() => import('./TransactionsCounterpartiesMergeModal'))

const TransactionCounterpartiesMergeButton = ({ selectedRows, onSuccessfulMerge }) => {
  const [modalVisible, setModalVisible] = useState(false)

  return (
    <>
      <PermissionGate
        requiredRole='dashboardEditor'
        toolTipText='Only admins and dashaboard editors can merge transaction counterparties.'
        readOnly={
          <Button size='small' disabled variant='contained' sx={{ fontSize: 14, textTransform: 'none', width: '10%' }}>
            Merge
          </Button>
        }
      >
        {selectedRows.length ? (
          <Button
            disableElevation
            size='small'
            variant='contained'
            sx={{ fontSize: 14, textTransform: 'none', width: '10%' }}
            onClick={() => {
              setModalVisible(true)
            }}
          >
            Merge
          </Button>
        ) : (
          <Button
            disableElevation
            size='small'
            variant='contained'
            sx={{ fontSize: 14, textTransform: 'none', width: '10%' }}
            disabled
          >
            Merge
          </Button>
        )}
      </PermissionGate>

      <Suspense fallback={<></>}>
        <TransactionsCounterpartiesMergeModal
          modalVisible={modalVisible}
          handleCancelModal={() => setModalVisible(false)}
          transactionCounterparties={selectedRows}
          onSuccessfulMerge={onSuccessfulMerge}
        />
      </Suspense>
    </>
  )
}

export default TransactionCounterpartiesMergeButton
